import { Badge } from '@/components/ui/badge';
import {
  faTriangleExclamation,
  faMinus,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Rechtshinweis } from '../../entities';

export function RechtshinweiseCell({
  rechtshinweise,
}: {
  rechtshinweise: Rechtshinweis[];
}) {
  return (
    <Badge
      className={`px-2 py-1.5 space-x-2 w-[50px] h-8 ${
        rechtshinweise.length < 1
          ? 'bg-neutrals-200'
          : 'bg-primary-red-100 hover:bg-primary-red-200'
      }`}
      variant="secondary">
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        size="xl"
        className={
          rechtshinweise.length > 0
            ? 'text-primary-red-400'
            : 'text-neutrals-600'
        }
      />
      {rechtshinweise.length > 0 ? (
        <span className="text-black font-bold">{rechtshinweise.length}</span>
      ) : (
        <FontAwesomeIcon
          icon={faMinus}
          size="sm"
          className="text-neutrals-600"
        />
      )}
    </Badge>
  );
}
